// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__38Z-D","header":"Messages_header__1KnF2"};